import { render } from "./ContentFileListModal.vue?vue&type=template&id=28ef8832"
import script from "./ContentFileListModal.vue?vue&type=script&lang=js"
export * from "./ContentFileListModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__